import { categories } from '@/mocks/categories';

const featuredCategories = categories.slice(0, 8);

const cardImages = [
  'https://readdy.ai/api/search-image?query=Pair%20of%20premium%20white%20leather%20high-top%20sneakers%20with%20gum%20sole%20photographed%20on%20rough%20stone%20pedestal%2C%20dramatic%20studio%20lighting%20from%20above%2C%20clean%20beige%20background%2C%20luxury%20product%20photography%20with%20crisp%20shadows%2C%20editorial%20fashion%20magazine%20style%2C%20minimalist%20composition%20emphasizing%20shoe%20craftsmanship&width=600&height=600&seq=cat-card-shoes&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Oversized%20charcoal%20gray%20fleece%20hoodie%20draped%20elegantly%20over%20minimalist%20wooden%20chair%2C%20soft%20diffused%20window%20light%2C%20clean%20cream%20wall%20background%2C%20cozy%20lifestyle%20photography%2C%20warm%20neutral%20tones%20with%20subtle%20texture%20details%2C%20editorial%20home%20fashion%20composition&width=600&height=600&seq=cat-card-hoodies&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Stack%20of%20folded%20premium%20cotton%20t-shirts%20in%20earth%20tones%20including%20olive%2C%20cream%2C%20and%20rust%20arranged%20on%20rough%20linen%20fabric%2C%20overhead%20flat%20lay%20photography%2C%20natural%20daylight%2C%20minimalist%20styling%2C%20editorial%20fashion%20photography%20with%20warm%20color%20palette&width=600&height=600&seq=cat-card-tshirts&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Vintage%20olive%20green%20utility%20jacket%20displayed%20on%20weathered%20wooden%20coat%20rack%20against%20whitewashed%20brick%20wall%2C%20warm%20golden%20hour%20lighting%2C%20editorial%20menswear%20photography%2C%20rugged%20yet%20refined%20aesthetic%2C%20film%20grain%20texture%2C%20lifestyle%20product%20shot&width=600&height=600&seq=cat-card-jackets&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Pair%20of%20tailored%20beige%20chino%20pants%20neatly%20folded%20with%20leather%20belt%20on%20raw%20wooden%20surface%2C%20soft%20natural%20lighting%20from%20window%2C%20clean%20minimalist%20composition%2C%20warm%20earth%20tones%2C%20premium%20menswear%20product%20photography%20with%20visible%20fabric%20texture&width=600&height=600&seq=cat-card-pants&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Collection%20of%20three%20stylish%20caps%20including%20baseball%20cap%2C%20bucket%20hat%20and%20beanie%20in%20neutral%20earth%20tones%20arranged%20on%20terrazzo%20surface%2C%20overhead%20flat%20lay%2C%20natural%20daylight%2C%20editorial%20accessories%20photography%2C%20minimalist%20composition%20with%20warm%20color%20harmony&width=600&height=600&seq=cat-card-headwear&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Matching%20camel%20colored%20tracksuit%20consisting%20of%20hoodie%20and%20joggers%20laid%20flat%20on%20cream%20velvet%20surface%2C%20soft%20studio%20lighting%2C%20clean%20aesthetic%2C%20editorial%20sportswear%20photography%2C%20warm%20neutral%20palette%2C%20professional%20product%20styling%20with%20subtle%20fabric%20texture&width=600&height=600&seq=cat-card-sets&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Premium%20cotton%20boxer%20briefs%20in%20white%20and%20heather%20gray%20neatly%20stacked%20on%20marble%20surface%20with%20eucalyptus%20sprig%2C%20minimalist%20composition%2C%20soft%20diffused%20lighting%2C%20luxury%20intimate%20apparel%20photography%2C%20clean%20and%20fresh%20aesthetic%2C%20editorial%20styling&width=600&height=600&seq=cat-card-underwear&orientation=squarish',
];

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Shop by<br />Category
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-md">
            Browse our comprehensive Superbuy Spreadsheet categories. Each category is packed with
            curated product finds, price comparisons, and community-verified recommendations.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.slice(0, 3).map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer ${
                idx === 0 ? 'lg:col-span-1 lg:row-span-2' : ''
              }`}
            >
              <div className={`${idx === 0 ? 'aspect-[3/4]' : 'aspect-square'}`}>
                <img
                  src={cardImages[idx]}
                  alt={`Superbuy Spreadsheet ${cat.name}`}
                  title={`Superbuy Spreadsheet ${cat.name} Category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-1">{cat.name}</h3>
                <p className="text-white/70 text-sm">Browse collection &rarr;</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5 mt-5 md:mt-6">
          {featuredCategories.slice(3, 8).map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-square"
            >
              <img
                src={cardImages[idx + 3]}
                alt={`Superbuy Spreadsheet ${cat.name}`}
                title={`Superbuy Spreadsheet ${cat.name} Category`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-white whitespace-nowrap">{cat.name}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}